import { SlicePipe } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { PopoverDirective } from "@kno2/common/directives";

@Component({
    selector: "kno2-multi-value-display",
    imports: [PopoverDirective, SlicePipe],
    templateUrl: "./multi-value-display.component.html"
})
export class MultiValueDisplayComponent {
    public values = input.required<string[]>();
    public showCount = input<number>(3);
    public delimiter = input<string>(", ");

    protected hasMore = computed(() => this.values().length > this.showCount());
    protected moreCount = computed(() => Math.max(0, this.values().length - this.showCount()));

    protected popover = computed(() => {
        const values = this.values();
        if (values.length === 0) return "";

        return values.map((value) => `<div class="hover-address">${value}</div>`).join("");
    });
}
